import { apolloClient } from "@td/ui";
import UPDATE_TASK_MUTATION from "../mutations/update-task.graphql";
import toastr from "../../toastr";
import { translate } from "@td/shared_utils";

const responseSelector = ({ data: { updateCareTeamTask }}) => updateCareTeamTask;

export default async (careTeamTaskId, formData) => {
  try {
    const data = await apolloClient.mutate({
      mutation: UPDATE_TASK_MUTATION,
      variables: {
        careTeamTaskId,
        formData,
      },
    });

    return responseSelector(data);
  } catch (e) {
    toastr.error(
      translate(null, "care_team_tasks", "server_error")
    );
  }
};
